import { Country, Currency } from "../global/types"
import { PaymentMethodType } from "../payment/types"

export enum PaymentMethod {
  card = "card",
  emi = "emi",
  upi = "upi",
  netbanking = "netbanking",
  wallet = "wallet",
  paylater = "paylater",
}

export enum IntervalType {
  day = "day",
  week = "week",
  month = "month",
  year = "year",
}

export type PaymentDetails =
  | {
      method: PaymentMethod.card
      network: string
      identifier: string
      type: string
      issuer: string | null
    }
  | {
      method: PaymentMethod.emi
      network?: string
      identifier?: string
      type?: string
      issuer?: string | null
    }
  | {
      method: PaymentMethod.upi
      identifier: string
    }
  | {
      method:
        | PaymentMethod.netbanking
        | PaymentMethod.wallet
        | PaymentMethod.paylater
      issuer: string
    }

export type SubscriptionDetails = {
  subscription: Subscription
  transactions?: Transaction[] | null
  product?: SubscriptionProduct | null
}

export type Transaction = {
  id: string
  orderId: string
  serialNumber: string
  amount: number
  paymentDetails: PaymentDetails | null
  currency: Currency
  createdAt: string
  intervalType: IntervalType
}

export type SubscriptionProduct = {
  id: number
  name: string
  slug: string
  isRepurchasable: boolean
  subscriptionDetails?: ProductSubscriptionDetails
}

export type Subscription = {
  id: string
  productId: string
  isFreeClaim: boolean
  orderId: string
  status: SuraasaPlusSubscriptionStatus
  startDate: string
  endDate?: string
  validThrough: string
  lastPaymentDate: string
  metaData: MetaDataForFreeClaim | MetaDataForPaidUser
  createdAt: string
  paymentDetails?: PaymentDetails | null
  mandateId: string
  gracePeriod: number
}

export type MetaDataForPaidUser = {
  paymentMethodId: string
  paymentPlanId: string
  orderId: string
  paymentMethodCode: PaymentMethodType
  paymentMethodMandateId: string
  orderIds: string[]
  isNy26?: boolean
}
export type MetaDataForFreeClaim = {
  freeClaim: boolean
  freeClaimIds: number[]
  isNy26: undefined
}

export type ProductSubscriptionDetails = {
  suraasaSubscriptionId: string | null
  suraasaPlanId: string | null
  billingInterval: number
  intervalType: IntervalType
}

export enum SuraasaPlusSubscriptionStatus {
  active = "active",
  cancelled = "cancelled",
  expired = "expired",
  paymentOverdue = "payment_overdue",
}

export enum SuraasaPlusSubscriptionMode {
  paid,
  freeTrial,
}

type ProductItem = {
  itemType: string
  itemId: number
  sequence: number
  learningMode: string | null
  deliveryMode: string | null
}

type ProductPrice = {
  country: Country
  currency: Currency
  tier: {
    tierId: string
    price: number //float
  } | null
  price: number //float
  mrp: number //float
  globallyAvailable: boolean
  inclusiveOfTax: boolean
  promocode?: {
    code: string
    discountPercentage: number
    priceAfterDiscount: number
  }
}

export type SuraasaPlusProduct = {
  id: number
  items: ProductItem[]
  price: ProductPrice
  name: string
  subscriptionDetails: {
    suraasaSubscriptionId: string | null
    suraasaPlanId: string | null
    billingInterval: number
    intervalType: IntervalType
  } | null
  slug: string
}

export type ProductDetails = {
  id: number
  name: string
  slug: string
  products: SuraasaPlusProduct[]
  isActive: boolean
}

export type RuleExecutionDetails = {
  maxExecutions: number
  totalExecutions: number
  ruleExecutionsDates: {
    ruleReaction: number
    total: number
    executionDates: string[]
  }[]
}
